var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReplayIcon = function SvgReplayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M63.12,13.26h0A35.11,35.11,0,0,0,15.64,15.6L8.81,9.9l-.12,22L30.27,27.8l-7.15-6a25.45,25.45,0,0,1,43,18.47,24,24,0,0,1-.2,3.17l9.89-1.89c0-.43,0-.85,0-1.28A35.1,35.1,0,0,0,63.12,13.26M58.3,58.62A25.45,25.45,0,0,1,15.19,40.28a27.71,27.71,0,0,1,.27-3.63L5.53,38.52c0,.59,0,1.17,0,1.76A35.17,35.17,0,0,0,40.63,75.46h0A35.13,35.13,0,0,0,65.81,64.84l6.52,5.41,0-22L50.81,52.42Z"
  })));
};

export default SvgReplayIcon;